export const LogRouting = [
  {
    path: "/work-manage/log/list",
    name: "work-manage-log-list",
    meta: { title: "施工日志" },
    notice: { type: "project_work_log_examine", hasNotice: false },
    component: () => import("@/views/work-manage/log/list/index.vue"),
  },
  {
    hidden: true,
    path: "/work-manage/log/create",
    name: "work-manage-log-create",
    meta: { title: "新增施工日志", comName: "WorkManageLogFormCreate" },
    component: () => import("@/views/work-manage/log/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/work-manage/log/edit/:id",
    name: "work-manage-log-edit",
    meta: { title: "编辑施工日志", comName: "WorkManageLogFormCreate" },
    component: () => import("@/views/work-manage/log/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/work-manage/log/detail/:id",
    name: "work-manage-log-detail",
    meta: { title: "施工日志详情" },
    component: () => import("@/views/work-manage/log/form-detail/index.vue"),
  },
  {
    hidden: true,
    path: "/work-manage/log/flowPrint/:id",
    name: "work-manage-log-print",
    meta: { title: "打印详情" },
    component: () => import("@/views/work-manage/log/form-print/index.vue"),
  },
];
